import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ChevronLeft, ClipboardList, KeyRound } from "lucide-react";
import Rota from "@/pages/Rota";
import StaffManagement from "@/components/StaffManagement";

const LOGO = "https://content.webfactorysite.co.uk/20260113092111-Wales-Event-Logo.png?t=1768296071";

export default function AdminStaff() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab") === "logins" ? "logins" : "rota";
  const [mgmtOpen, setMgmtOpen] = useState(false);

  useEffect(() => {
    if (tab === "logins") setMgmtOpen(true);
  }, [tab]);

  const tabCls = (active) =>
    `px-4 py-2.5 rounded-lg text-sm font-bold transition-colors min-h-[44px] ${active ? "bg-[#005EB8] text-white" : "text-[#0F2547] hover:bg-slate-100"}`;

  return (
    <div className="min-h-screen bg-[#F4F7FA]" data-testid="admin-staff-page">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 pt-3 flex items-center gap-3">
          <img src={LOGO} alt="Wales Event Medical Services" className="h-9 w-auto" />
          <div>
            <h1 className="font-heading text-xl sm:text-2xl font-bold text-[#0F2547]">Staff</h1>
            <p className="text-xs text-slate-500">Rota, people, pay & logins in one place</p>
          </div>
          <button onClick={() => navigate("/admin")} data-testid="admin-staff-back"
            className="ml-auto inline-flex items-center gap-2 text-xs font-semibold px-3 py-2.5 rounded-lg border border-slate-300 text-[#0F2547] hover:border-[#005EB8] hover:text-[#005EB8] transition-colors min-h-[44px]">
            <ChevronLeft className="h-4 w-4" /> Admin
          </button>
        </div>
        <div className="max-w-6xl mx-auto px-4 flex gap-2 pb-3 pt-2">
          <button onClick={() => setSearchParams({})} data-testid="admin-staff-tab-rota" className={tabCls(tab === "rota")}>
            <span className="inline-flex items-center gap-2"><ClipboardList className="h-4 w-4" /> People & rota</span>
          </button>
          <button onClick={() => setSearchParams({ tab: "logins" })} data-testid="admin-staff-tab-logins" className={tabCls(tab === "logins")}>
            <span className="inline-flex items-center gap-2"><KeyRound className="h-4 w-4" /> Logins & access</span>
          </button>
        </div>
      </header>

      {tab === "rota" ? (
        <Rota embedded />
      ) : (
        <main className="max-w-3xl mx-auto p-4 sm:p-8">
          <div className="bg-white rounded-2xl border border-slate-200 p-8 text-center">
            <div className="h-14 w-14 rounded-2xl bg-[#F4F7FA] border border-slate-200 grid place-items-center mx-auto mb-4">
              <KeyRound className="h-7 w-7 text-[#005EB8]" />
            </div>
            <p className="font-bold text-[#0F2547] text-base">Staff logins & access</p>
            <p className="text-sm text-slate-500 mt-1 mb-5">Create logins, set roles & grades, manage invites and passwords.</p>
            <button onClick={() => setMgmtOpen(true)} data-testid="admin-staff-open-logins"
              className="h-12 px-6 rounded-lg bg-[#005EB8] hover:bg-[#004a93] transition-colors text-white text-sm font-semibold">
              Open staff manager
            </button>
          </div>
          <StaffManagement open={mgmtOpen} onOpenChange={setMgmtOpen} />
        </main>
      )}
    </div>
  );
}
